export default __webpack_public_path__ + "static/media/UserPlaceholder.840038da.svg";